import { cachedDateFormat } from '@/lib/dateLocale';

/**
 * Calendar days for the When card, formatted in UTC so a day never drifts
 * (CLAUDE.md: plan dates are calendar days, not instants).
 */
const dayMonth = cachedDateFormat({ day: 'numeric', month: 'short', timeZone: 'UTC' });
const dayMonthYear = cachedDateFormat({
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
});

const parse = (iso: string): number => Date.parse(`${iso}T00:00:00Z`);

/** "18 Aug" */
export const formatDayMonth = (iso: string): string => dayMonth().format(parse(iso));

/** "18 Aug 2026" */
export const formatDay = (iso: string): string => dayMonthYear().format(parse(iso));

/** "18 Aug – 18 Dec 2026", or both years when they differ. */
export const formatRange = (startIso: string, endIso: string): string =>
  startIso.slice(0, 4) === endIso.slice(0, 4)
    ? `${formatDayMonth(startIso)} – ${formatDay(endIso)}`
    : `${formatDay(startIso)} – ${formatDay(endIso)}`;
